import ActionButton, { IActionButtonModifiers } from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { IOrderViewerMainStore } from '../../typing/stores';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';

interface IPrintReceiptButton {
	orderId?: number;
}

const PrintReceiptButton: React.FunctionComponent<
	IPrintReceiptButton & IActionButtonCommonProps & IActionButtonModifiers
> = props => {
	const handler = () => {
		const url = RFE.combineRoot('order/GenPrintReceipt.aspx?popup=yes&Id=' + props.orderId);
		window.open(url, '_blank', '');
	};

	return (
		<ActionButton
			label={localize('Print receipt')}
			handler={handler}
			icon={Icons.PrintIcon}
			isPrimary={props.isPrimary}
			testId="print-receipt-btn"
			{...props}
		/>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	orderId: stores.orderViewerStore.viewModel.orderId
}))(PrintReceiptButton);
